import { useState } from "react";
import { FiSearch, FiCalendar, FiChevronDown, FiPlus } from "react-icons/fi";

import { FaXRay } from "react-icons/fa";

import { GiMedicines } from "react-icons/gi";

import { MdOutlineMonitorHeart } from "react-icons/md";

const reports = [
  // ==================== Radiology ====================
  {
    id: "RAD-2026-1008",
    category: "Radiology",
    testCategory: "X-Ray",
    test: "Chest X-Ray (PA View)",
    body: "Chest",
    doctor: "Dr. Hari Prakash",
    technician: "Arun Kumar",
    date: "01 Jul 2026",
    status: "Completed",
    billing: "Paid",
    icon: <FaXRay className="text-blue-600" />,
  },
  {
    id: "RAD-2026-1007",
    category: "Radiology",
    testCategory: "CT Scan",
    test: "CT Brain",
    body: "Brain",
    doctor: "Dr. Hari Prakash",
    technician: "Karthik",
    date: "30 Jun 2026",
    status: "Completed",
    billing: "Insurance",
    icon: <MdOutlineMonitorHeart className="text-cyan-600" />,
  },
  {
    id: "RAD-2026-1006",
    category: "Radiology",
    testCategory: "MRI",
    test: "MRI Spine",
    body: "Spine",
    doctor: "Dr. Hari Prakash",
    technician: "Arun Kumar",
    date: "28 Jun 2026",
    status: "Pending",
    billing: "Pending",
    icon: <GiMedicines className="text-pink-600" />,
  },
  {
    id: "RAD-2026-1005",
    category: "Radiology",
    testCategory: "Ultrasound",
    test: "USG Abdomen",
    body: "Abdomen",
    doctor: "Dr. Hari Prakash",
    technician: "Priya",
    date: "27 Jun 2026",
    status: "Pending",
    billing: "Pending",
    icon: <FaXRay className="text-violet-600" />,
  },

  // ==================== Pathology ====================
  {
    id: "PAT-2026-1004",
    category: "Pathology",
    testCategory: "Hematology",
    test: "Complete Blood Count (CBC)",
    body: "Whole Blood",
    doctor: "Dr. Hari Prakash",
    technician: "Rahul",
    date: "26 Jun 2026",
    status: "Completed",
    billing: "Paid",
    icon: <GiMedicines className="text-red-600" />,
  },
  {
    id: "PAT-2026-1003",
    category: "Pathology",
    testCategory: "Biochemistry",
    test: "Liver Function Test (LFT)",
    body: "Serum",
    doctor: "Dr. Hari Prakash",
    technician: "Karthik",
    date: "25 Jun 2026",
    status: "Completed",
    billing: "Insurance",
    icon: <MdOutlineMonitorHeart className="text-amber-600" />,
  },
  {
    id: "PAT-2026-1002",
    category: "Pathology",
    testCategory: "Urinalysis",
    test: "Urine Routine Examination",
    body: "Urine",
    doctor: "Dr. Hari Prakash",
    technician: "Priya",
    date: "24 Jun 2026",
    status: "Pending",
    billing: "Pending",
    icon: <GiMedicines className="text-green-600" />,
  },
  {
    id: "PAT-2026-1001",
    category: "Pathology",
    testCategory: "Microbiology",
    test: "Blood Culture",
    body: "Blood",
    doctor: "Dr. Hari Prakash",
    technician: "Arun Kumar",
    date: "23 Jun 2026",
    status: "Completed",
    billing: "Paid",
    icon: <MdOutlineMonitorHeart className="text-purple-600" />,
  },
];

export default function Radiology() {
  const [status, setStatus] = useState("All Status");
  const [billing, setBilling] = useState("All Billing");

  const filtered = reports.filter((item) => {
    const statusMatch = status === "All Status" ? true : item.status === status;

    const billingMatch =
      billing === "All Billing" ? true : item.billing === billing;

    return statusMatch && billingMatch;
  });

  return (
    <div className="rounded-xl border bg-white shadow-sm">
      {/* Header */}

      <div className="flex items-center justify-between border-b px-5 py-4">
        <h2 className="text-lg font-bold text-[#283593]">
          Radiology / Pathology
        </h2>

        <input
          type="date"
          className="h-8 rounded-md border border-[#e5e7eb] bg-white px-4 text-[13px] font-semibold text-[#111827] outline-none focus:border-[#5b5bd6]"
        />
      </div>

      {/* Filters */}

      <div className="flex flex-wrap items-center gap-3 p-5">
        {/* Status */}

        <select
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          className="rounded-lg border px-3 py-2 text-xs outline-none"
        >
          <option>All Status</option>
          <option>Completed</option>
          <option>Pending</option>
        </select>

        {/* Billing */}

        <select
          value={billing}
          onChange={(e) => setBilling(e.target.value)}
          className="rounded-lg border px-3 py-2 text-xs outline-none"
        >
          <option>All Billing</option>
          <option>Paid</option>
          <option>Insurance</option>
          <option>Pending</option>
        </select>

        {/* Search */}

        <div className="relative ml-auto">
          <FiSearch className="absolute left-3 top-3 text-gray-400" />

          <input
            placeholder="Search Test / Report ID"
            className="w-64 rounded-lg border py-2 pl-9 pr-3 text-xs outline-none"
          />
        </div>
      </div>
      {/* Table */}

      <div className="overflow-x-auto px-5 pb-5">
        <table className="min-w-full text-xs">
          <thead className="bg-gray-50 text-gray-700">
            <tr>
              <th className="p-3 text-left"></th>

              <th className="p-3 text-left">Report ID</th>

              <th className="p-3 text-left">Test / Procedure</th>

              {/* New Column */}
              <th className="p-3 text-left">Category</th>

              <th className="p-3 text-left">Body Part</th>

              <th className="p-3 text-left">Ordered By</th>

              <th className="p-3 text-left">Technician</th>

              <th className="p-3 text-left">Schedule</th>

              <th className="p-3 text-left">Status</th>

              <th className="p-3 text-left">Billing</th>

              <th className="p-3 text-center">Action</th>
            </tr>
          </thead>

          <tbody>
            {filtered.map((item, index) => (
              <tr key={index} className="border-t hover:bg-gray-50 transition">
                {/* Icon */}

                <td className="p-3">
                  <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-cyan-50 text-lg">
                    {item.icon}
                  </div>
                </td>

                {/* Report ID */}

                <td className="p-3 font-semibold text-[#283593]">{item.id}</td>

                {/* Test */}

                <td className="p-3">
                  <div className="font-medium">{item.test}</div>

                  <div className="mt-1 text-[10px] text-gray-500">
                    Radiology Procedure
                  </div>
                </td>
                {/* Category */}

                <td className="p-3">
                  <span className="rounded-md bg-cyan-100 px-2 py-1 text-[10px] font-semibold text-cyan-700">
                    {item.category}
                  </span>
                </td>
                {/* Body */}

                <td className="p-3">{item.body}</td>

                {/* Doctor */}

                <td className="p-3">{item.doctor}</td>

                {/* Technician */}

                <td className="p-3">{item.technician}</td>

                {/* Schedule */}

                <td className="p-3">{item.date}</td>

                {/* Status */}

                <td className="p-3">
                  <span
                    className={`rounded-md px-2 py-1 text-[10px] font-semibold
                    ${
                      item.status === "Completed"
                        ? "bg-green-100 text-green-700"
                        : "bg-orange-100 text-orange-700"
                    }`}
                  >
                    {item.status}
                  </span>
                </td>

                {/* Billing */}

                <td className="p-3">
                  <span
                    className={`rounded-md px-2 py-1 text-[10px] font-semibold

                    ${
                      item.billing === "Paid"
                        ? "bg-green-100 text-green-700"
                        : item.billing === "Insurance"
                          ? "bg-purple-100 text-purple-700"
                          : "bg-red-100 text-red-700"
                    }`}
                  >
                    {item.billing}
                  </span>
                </td>

                {/* Action */}

                <td className="p-3">
                  <div className="flex justify-center gap-2">
                    <button className="rounded-lg bg-white border border-blue-200 p-2 text-blue-600 hover:bg-blue-50">
                      👁
                    </button>

                    <button className="rounded-lg bg-white border border-green-200 p-2 text-green-600 hover:bg-green-50">
                      ✏
                    </button>

                    <button className="rounded-lg bg-white border border-purple-200 p-2 text-purple-600 hover:bg-purple-50">
                      🖨
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Footer */}

      <div className="flex flex-col items-center justify-between gap-4 border-t px-5 py-4 md:flex-row">
        {/* Left */}

        <p className="text-xs text-gray-500">
          Showing 1 to {filtered.length} of {filtered.length} reports
        </p>

        {/* Pagination */}

        <div className="flex items-center gap-2">
          <button className="flex h-8 w-8 bg-white items-center justify-center rounded-md border text-gray-500 hover:bg-gray-100">
            &laquo;
          </button>

          <button className="flex h-8 w-8 bg-white items-center justify-center rounded-md bg-cyan-600 text-white">
            1
          </button>

          <button className="flex h-8 w-8 bg-white items-center justify-center rounded-md border hover:bg-gray-100">
            2
          </button>

          <button className="flex h-8 w-8 bg-white items-center justify-center rounded-md border text-gray-500 hover:bg-gray-100">
            &raquo;
          </button>
        </div>

        {/* Rows Per Page */}

        <div className="flex items-center gap-2 text-xs">
          <span className="text-gray-500">Rows per page</span>

          <select className="rounded-md border px-2 py-1 outline-none">
            <option>10</option>
            <option>20</option>
            <option>50</option>
          </select>
        </div>
      </div>
    </div>
  );
}
